<div class="cardLayout">
<ion-row>
  <ion-col size="12">
    <div class="popup-heading">
      <div>
        <p class="fs-16 font_regular">{{employeeName}}</p>
       </div>
       <div class="popup-close">  
        <button class="download-btn" (click)="onClickDownloadLetter()" >
          <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
          Download
        </button>
        <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
      </div>
    </div>
  </ion-col>
</ion-row>

</div>

<mat-dialog-content>



<ion-row>

  <ion-col size="12">
 <div class="mt-20" *ngIf="letterUrl; else noLetter">
  <!-- <iframe [src]="letterUrl" style="width:100%; height:600px; border:none;"></iframe> -->
   <!-- <pdf-viewer [src]="letterUrl" [render-text]="true" [original-size]="false" [zoom]="1.5"></pdf-viewer> -->
<iframe
  [src]="letterUrl"
  width="100%"
  height="600"
  style="border:none"
></iframe>


</div>
    
    <ng-template #noLetter>
      <p style="text-align: center; font-weight: bold; color: red;">
        No letter available for this user.
      </p>
    </ng-template>
    
  </ion-col>
</ion-row>
</mat-dialog-content>
<!-- <html>
<head>
  <script type="text/javascript"></script>
  <title>Email Template </title>
  <style>
    .Incrementletter {
      overflow-y: scroll;
      height: 80vh;
    }
    .gradient {
      background: linear-gradient(to right, #F3820E, #393186);
      height: 22px;
      width: 100%;
    }

    .letter-content {
      margin-top: 30px;
    }

    .border-bottom {
      border-bottom: 1px solid #C8C8C8;
      width: 100%;
      margin-top: 4%;
      margin-bottom: 4%;
    }

    table {
      margin-top: 20px;
    }

    table th,
    td {
      border: 1px solid black;
      padding: 14px 10px 14px 10px;
    }

    table th:first-child {
      width: 340px;
    }

    table td:first-child {
      width: 340px;
    }
  </style>
</head>
<body>
  <div class="Incrementletter">
    <div class="letter-content">
      <div class="gradient"></div>
      <div style="padding: 5%;">
        <img class="company-logo" src="././assets/icon/catalystLogo.svg" alt="company-logo" />
        <div class="border-bottom"></div>
        <p>
          Date: [DD/MM/YYYY]
          <br><br>
          To, [Employee's Name]
          <br /><br />
          [Employee's Designation]
          <br /><br>
          [Department]
          <br><br>
          [Employee's office location]
          <br> <br>
          Subject: Salary Increment Notification
          <br><br>
          Dear [Employee's Name],
          <br><br>
          Basis your annual performance for the year 23-24, you have been awarded a performance rating of [rating] and
          we
          are pleased to inform you basis your band, your effective all inclusive increment %ge is [Increment %ge]. This
          increment reflects your hard work, dedication, and the significant contributions you have made to the company.
          Your revised annual CTC post increment is [New annual CTC Amount]. Promotion content: We are also delighted to
          inform that you have been promoted wef 1st April 2024 and your new designation is [revised designation].
          Please
          note that the revised salary will be effective from 1st Pril 2024 and will reflect in your payslip. We
          appreciate your continued efforts and dedication to your role. If you have any questions or require further
          clarification regarding this increment, please feel free to reach out to the HR department.
          <br><br>
          Congratulations!!
          <br><br>
          Sincerely,
          <br><br>
          Digital signature
          <br><br>
          Name of Head HR
          <br><br>
          Designation
        </p>
        <br><br>
        <div style="display: flex; justify-content: space-between;">
          <p>91 0000000000</p>
          <p>www.companyname.com</p>
          <p>info&#64;companyname.com</p>
        </div>
        <br><br>
        <div>
          <p>Registered Address:</p>
        </div>
      </div>
      <div class="gradient"></div>
    </div>
    <div class="letter-content">
      <div class="gradient"></div>
      <div style="padding: 5%;">
        <img class="company-logo" src="././assets/icon/catalystLogo.svg" alt="company-logo" />
        <div class="border-bottom"></div>
        <p>
          Date: [DD/MM/YYYY]
          <br><br>
          To, [Employee's Name]
          <br><br>
          [Employee's Designation]
          <br><br>
          [Department]
          <br><br>
          [Employee's office location]
          <br> <br>
          Employee Office Location
          <br><br>
        <table>
          <tr>
            <th>SALARY COMPONENTS</th>
            <th>MONTHLY</th>
            <th>ANNUALLY</th>
          </tr>
          <tr>
            <td>Basic Pay</td>
            <td>&#8377; 9,520.00</td>
            <td>&#8377; 1,13,240.00</td>
          </tr>
          <tr>
            <td>HRA</td>
            <td>&#8377; 3,808.00</td>
            <td>&#8377; 45,696.00</td>
          </tr>
          <tr>
            <td>Other Allowances</td>
            <td>&#8377; 9,072.00</td>
            <td>&#8377; 1, 08, 864.00</td>
          </tr>
          <tr>
            <td style="font-weight: bold; text-align: right;">Gross Payment</td>
            <td style="font-weight: bold;">&#8377; 22,400.00</td>
            <td style="font-weight: bold;">&#8377; 1, 08, 864.00</td>
          </tr>
          <tr>
            <td style="font-weight: bold; text-align: right;">Gross For PF</td>
            <td style="font-weight: bold;">&#8377; 22,400.00</td>
            <td style="font-weight: bold;">&#8377; 1, 08, 864.00</td>
          </tr>
          <tr>
          </tr>
          <tr>
            <td style="font-weight: bold;">Statutory Bonus</td>
            <td style="font-weight: bold;">&#8377; 1,400.00</td>
            <td style="font-weight: bold;">&#8377; 16, 864.00</td>
          </tr>
          <tr>
            <td style="text-align: center; font-weight: bold;" colspan="2">STATUTORY CONTRIBUTION</td>
            <td></td>
          </tr>
          <tr>
            <td>PF 12 % On Gross for PF or 1800 whichever is lower (Employee Contribution)</td>
            <td>&#8377; 1, 800.00</td>
            <td>&#8377; 21, 600.00</td>
          </tr>
          <tr>
            <td style="font-weight: bold;">TOTAL COST TO COMPANY</td>
            <td style="font-weight: bold;">&#8377; 23, 600.00</td>
            <td style="font-weight: bold;">&#8377; 2, 85, 600.00</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td style="text-align: center; font-weight: bold;" colspan="2">STATUTORY DEDUCTIONS</td>
            <td></td>
          </tr>
          <tr>
            <td>PF 12 % On Gross for PF or 1800 whichever is lower (Employee Contribution)</td>
            <td>&#8377; 1, 800.00</td>
            <td>&#8377; 21, 600.00</td>
          </tr>
          <tr>
            <td>Professional Tax</td>
            <td>&#8377; 200.00</td>
            <td>&#8377; 2, 500.00</td>
          </tr>
        </table>
        <table>
          <tr>
            <th>Total In Hand</th>
            <th>&#8377; 20,000,00</th>
            <th>&#8377; 2,39, 900.00</th>
          </tr>
        </table>
        <br><br>
        <div style="display: flex; justify-content: space-between;">
          <p>91 0000000000</p>
          <p>www.companyname.com</p>
          <p>info&#64;companyname.com</p>
        </div>
        <br><br>
        <div>
          <p>Registered Address:</p>
        </div>
      </div>
      <div class="gradient"></div>
    </div>
    <div class="letter-content">
      <div class="gradient"></div>
      <div style="padding: 5%;">
        <img class="company-logo" src="././assets/icon/catalystLogo.svg" alt="company-logo" />
        <div class="border-bottom"></div>
        <p>
          Date: [DD/MM/YYYY]
          <br><br>
          To, [Employee's Name]
          <br><br>
          [Employee's Designation]
          <br><br>
          [Department]
          <br><br>
          [Employee's office location]
          <br> <br>
          Subject: Salary Increment Notification
          <br><br>
          Dear [Employee's Name],
          <br><br>
          Basis your annual performance for the year 23-24, you have been awarded a performance rating of [rating] and
          we
          are pleased to inform you basis your band, your effective all inclusive increment %ge is [Increment %ge]. This
          increment reflects your hard work, dedication, and the significant contributions you have made to the company.
          Your revised annual CTC post increment is [New annual CTC Amount]. Promotion content: We are also delighted to
          inform that you have been promoted wef 1st April 2024 and your new designation is [revised designation].
          Please
          note that the revised salary will be effective from 1st Pril 2024 and will reflect in your payslip. We
          appreciate your continued efforts and dedication to your role. If you have any questions or require further
          clarification regarding this increment, please feel free to reach out to the HR department.
          <br><br>
          Congratulations!!
          <br><br>
          Sincerely,
          <br><br>
          Digital signature
          <br><br>
          Name of Head HR
          <br><br>
          Designation
        </p>
        <br><br>
        <div style="display: flex; justify-content: space-between;">
          <p>91 0000000000</p>
          <p>www.companyname.com</p>
          <p>info&#64;companyname.com</p>
        </div>
        <br><br>
        <div>
          <p>Registered Address:</p>
        </div>
      </div>
      <div class="gradient"></div>
    </div>
  </div>
</body>
</html> -->